interface Props {
  size?: number;
  color?: string;
}

const CurrencyExchangeIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 24 24`}
    >
      <g
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="1.92"
        clipPath="url(#clip0_416_21708)"
      >
        <path
          strokeLinecap="square"
          d="M12.043 14.87a2.87 2.87 0 1 0 0-5.74 2.87 2.87 0 0 0 0 5.74Z"
        ></path>
        <path d="M22.582 6.251v9.58a2.87 2.87 0 0 1-2.87 2.88H7.252l3.83 3.83M4.38 12h1.91M17.791 12h1.92M1.501 17.751v-9.58a2.88 2.88 0 0 1 2.88-2.88h12.45l-3.83-3.83"></path>
      </g>
      <defs>
        <clipPath id="clip0_416_21708">
          <path fill={'#fff'} d="M0 0h24v24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default CurrencyExchangeIcon;
